<div ngbDropdown container="body" class="dropdown dropdown--remove-arrow" (openChange)="dropdownClosed($event)">
  <div class="dropdown" ngbDropdownToggle #toggle>
    <div class="d-flex align-items-center" [class.large-input]="largeInput">
      <div class="form-floating flex-grow-1 date-wrapper">
        <div class="input-group">
          <input id="datepicker" name="datepicker" [readonly]="true" class="form-control date-input"
            [value]="getValue()" [placeholder]="'Početak-kraj događaja'" />
          <button class="btn btn-outline-secondary bi bi-calendar3" type="button"></button>
        </div>
      </div>
    </div>
  </div>
  <div ngbDropdownMenu class="dropdown-menu p-0">

    <ngb-datepicker #dp (dateSelect)="onDateSelection($event)" [displayMonths]="2" [footerTemplate]="footerTemplate"
      #calendar="ngbDatepicker" [minDate]="calendarStart" [maxDate]="calendarEnd" [dayTemplate]="t"></ngb-datepicker>
    <ng-template #t let-date let-focused="focused">
      <span class="custom-day" [class.focused]="focused" [class.disabled]="isDisabled(date)"
        [class.today]="isToday(date)" [class.range]="isRange(date)" [class.faded]="isHovered(date) || isInside(date)"
        (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
        {{ date.day }}
      </span>
    </ng-template>
    <ng-template #footerTemplate>
      <hr class="my-0" />
      <button class="btn btn-circle btn-secondary btn-sm m-2 float-end" (click)="toggle.click()">
        <i class="bi bi-search"></i>
      </button>
    </ng-template>
  </div>
</div>